import { defineComponent as _defineComponent } from 'vue'

export enum OzBadgeColorScheme {
  /**
   * **Bare**
   */
  Bare = 'Bare',
  /**
   * **Default**
   *
   * - Light mode: grey-700
   * - Dark mode: grey-200
   */
  Default = 'Default',
  /**
   * **Selection**
   *
   * - Light mode: grape-500
   * - Dark mode: canary-500
   */
  Selection = 'Selection',
  /**
   * **Disabled**
   *
   * - Light mode: dark-text-300
   * - Dark mode: light-text-300
   */
  Disabled = 'Disabled',
}

export enum OzBadgeSizePreset {
  Bare = 'Bare',
  Default = 'Default',
}

const __default__ = {}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzBadge',
  props: {
    darkMode: { type: [Boolean, String], default: 'auto' },
    text: null,
    colorScheme: null,
    sizePreset: { default: OzBadgeSizePreset.Default }
  },
  setup(__props: any) {



return { __sfc: true,OzBadgeColorScheme, OzBadgeSizePreset }
}

})